import createRouter from 'router5';
import browserPlugin from 'router5-plugin-browser';
import listenersPlugin from 'router5-plugin-listeners';

import {
  ACCESS_DENIED,
  ADD_ACCOUNT,
  ADMIN,
  ADMIN_ACTIONS_STATS,
  ADMIN_ADS,
  ADMIN_BATTLE,
  ADMIN_BATTLE_CREATE,
  ADMIN_BROADCASTS,
  ADMIN_FINANCE,
  ADMIN_MESSAGES,
  ADMIN_CHATS,
  ADMIN_MINE_EXPLORE_CARDS,
  ADMIN_MODEL_ADS,
  ADMIN_MODERATION,
  ADMIN_MODERATION_VIEW,
  ADMIN_MODERATIONS,
  ADMIN_MODERATIONS_LIST,
  ADMIN_MODERATION_STATS,
  ADMIN_MODERATION_QUEUE,
  ADMIN_OTHER,
  ADMIN_PROMO_CODE,
  ADMIN_PROMO_CODES,
  ADMIN_REPORTS,
  ADMIN_SPAM_CASES,
  ADMIN_SPAM_CASE,
  ADMIN_TOP,
  ADMIN_TRANSACTIONS,
  ADMIN_TRANSLATIONS,
  ADMIN_TRANSLATIONS_LANGUAGE,
  ADMIN_USER_PROFILE,
  ADMIN_USERS,
  ADMIN_UTM_MODEL_LIST,
  ADMIN_AUDIT_LOG,
  ADMIN_MODERATION_LOGS,
  ADMIN_BLACKLIST,
  ADMIN_WITHDRAWALS,
  ADS,
  ADULT_AUTH,
  AGENT,
  API_TOKEN,
  OAUTH_AUTHORIZE,
  APP,
  APPS_MANAGE,
  AUTH,
  AUTH_EMAIL,
  AUTH_PAGE,
  AUTH_REQUIRED,
  BATTLE,
  BATTLES,
  BIRTHDAYS,
  BLACK_FRIDAY_2025,
  BIND_EMAIL,
  BIND_EMAIL_CONFIRM,
  BLACKLIST,
  BLOCKED,
  COUNTRY_BLOCKED,
  BOT,
  BROADCAST,
  BROADCAST_MESSAGE,
  BROADCAST_STATS,
  BUY_MESSAGE_FAILED,
  CANDY_QR,
  CHAT,
  CLOUD,
  COMMON_FEED,
  CONTENT_PRIORITY,
  CUSTOM_TIPS,
  DASHBOARD,
  DEBUG_PAGE,
  EXPLORE,
  FAQ,
  FEED,
  FEED_PROMOTION,
  FIND_FRIENDS,
  FREE_WRITE,
  GENDER_FILTER,
  GOOGLE_AUTH,
  GROUP,
  GROUPS,
  HOWTO,
  IM,
  INCOGNITO,
  INVITE,
  ISOLATED_MODE,
  LANDING_DIAMOND,
  LANGUAGE,
  LEADERBOARD,
  LEADERBOARD_DETAILS,
  LEADERBOARDS_HISTORY,
  LIST,
  LISTS,
  LIVE,
  MAIN,
  MARYANA_LANDING,
  MEDIA,
  MINE,
  MINE_BOOST,
  MINE_EXPLORE,
  MINE_FRIENDS,
  MINE_SQUAD,
  MINE_SQUAD_BOOST,
  MINE_TOP,
  MODEL_UTM,
  NFT,
  NOTIFY,
  NOTIFY_SETTINGS,
  OFFERS,
  ONLYPAY_ERROR,
  ONLYPAY_SUCCESS,
  OTHER,
  PASSKEY,
  PASSWORD,
  PAY_FORM,
  PAY_TIPS_FAILED,
  PAYMENT_METHODS,
  PERSONAL_SUBSCRIPTION,
  PERSONAL_SUBSCRIPTION_INFO,
  POST_VIEW,
  PRE_LANDING_V1,
  PRE_LANDING_V2,
  PRE_LANDING_V3,
  PROFILE,
  PROFILE_LIVE,
  PROFILE_REDIRECT,
  PROFILE_REELS,
  PROMO_CODE,
  PWA_IOS,
  REELS,
  REF,
  REF_LANDING,
  REFILL_TON,
  REGISTRATION,
  RESOLVE,
  SEARCH,
  SESSIONS,
  SETTINGS,
  SHARE_PROFILE,
  SHOW_SUBSCRIPTION,
  STATISTICS,
  STATISTICS_PRO,
  STATISTICS_PRO_FANS,
  STATISTICS_PRO_LINKS,
  STORAGE,
  STORY_LANDING,
  SUBSCRIPTION,
  SUBSCRIPTION_ACTIVATED,
  SUBSCRIPTION_ADULT,
  SUBSCRIPTION_ADULT_ACTIVATED,
  SUBSCRIPTION_AUTHOR,
  SUBSCRIPTION_AUTHOR_ACTIVATED,
  SUBSCRIPTION_AUTHOR_OLD,
  SUBSCRIPTION_BASIC,
  SUBSCRIPTION_FAILED,
  SUBSCRIPTION_INFO,
  SUBSCRIPTION_MEDIA,
  SUBSCRIPTION_MEDIA_ACTIVATED,
  SUBSCRIPTION_TONKEEPER,
  SUBSCRIPTIONS,
  SYSTEM_PROMO_CODE,
  TELEGRAM,
  TOP_UP,
  TOP_UP_FAILED,
  TRIAL_LINK_ACTIVATION,
  TRIAL_LINKS,
  USER_REF,
  VALENTINE_DAY_STICKER,
  VERIFICATION_APPLY,
  VERIFICATION_LANDING,
  VIEW_OFFER,
  VK_AUTH,
  WEBSITE_SETTINGS,
  WELCOME_MESSAGE,
} from 'shared/constants/pages';
import { IS_PRODUCTION } from '$shared/constants';
import { sendEvent } from '$utils';

function sanitizeUrl(url) {
  // Декодируем URL, удаляем нелегальные символы и затем снова кодируем
  const decodedUrl = decodeURIComponent(url);
  const sanitizedUrl = decodedUrl.replace(/[^\w\/:.-]+/g, '');
  return sanitizedUrl.replace(
    /[!'()*]/g,
    (c) => '%' + c.charCodeAt(0).toString(16).toUpperCase(),
  );
}

try {
  const startPath = window.location.pathname;
  const sanitizedPath = sanitizeUrl(startPath);
  if (sanitizedPath !== startPath) {
    window.history.replaceState(null, document.title, sanitizedPath);
  }
} catch (e) {}

const routes = [
  { name: MAIN, path: '/' },
  { name: REGISTRATION, path: '/registration' },
  { name: FEED, path: '/feed' },
  { name: COMMON_FEED, path: '/feed/common' },
  { name: FEED_PROMOTION, path: '/feed/promotion' },
  { name: FREE_WRITE, path: '/free_write' },
  { name: PROFILE_REDIRECT, path: '/profile' },
  { name: PROFILE, path: '/id:id<\\d+>' },
  { name: PROFILE_REELS, path: '/id:id<\\d+>/reels' },
  { name: GROUP, path: '/group:id<\\d+>' },
  { name: SEARCH, path: '/search' },
  { name: NOTIFY, path: '/notify' },
  { name: OTHER, path: '/other' },
  { name: INVITE, path: '/invite' },
  { name: IM, path: '/im' },
  { name: BUY_MESSAGE_FAILED, path: '/buy_message_failed/:peerId' },
  { name: PAY_TIPS_FAILED, path: '/pay_tips_failed/:toId' },
  { name: BROADCAST, path: '/im/broadcast' },
  { name: BROADCAST_MESSAGE, path: '/im/broadcast/message' },
  { name: BROADCAST_STATS, path: '/im/broadcast/stats' },
  { name: CHAT, path: '/im:peerId' },
  { name: MEDIA, path: '/im:peerId/media' },
  { name: GROUPS, path: '/groups?:section' },
  { name: AUTH_REQUIRED, path: '/auth_required' },
  { name: AUTH_PAGE, path: '/auth' },
  { name: ACCESS_DENIED, path: '/access_denied' },
  { name: BLOCKED, path: '/blocked' },
  { name: COUNTRY_BLOCKED, path: '/country_blocked' },
  { name: FIND_FRIENDS, path: '/find_friends' },
  { name: VK_AUTH, path: '/vkauth' },
  { name: ADULT_AUTH, path: '/l/adult' },
  { name: AUTH_EMAIL, path: '/auth/email/confirm' },
  { name: AUTH, path: '/auth/:hash' },
  { name: SETTINGS, path: '/settings' },
  { name: ADD_ACCOUNT, path: '/settings/add_account' },
  { name: LANGUAGE, path: '/settings/language' },
  { name: PASSWORD, path: '/settings/password' },
  { name: BIND_EMAIL, path: '/settings/email' },
  { name: BIND_EMAIL_CONFIRM, path: '/email/bind/confirm' },
  { name: WELCOME_MESSAGE, path: '/settings/welcome_message' },
  { name: CONTENT_PRIORITY, path: '/content_priority' },
  { name: GENDER_FILTER, path: '/gender_filter' },
  { name: BIRTHDAYS, path: '/birthdays' },
  { name: SUBSCRIPTION, path: '/subscription' },
  { name: SUBSCRIPTION_FAILED, path: '/subscription_failed' },
  { name: SUBSCRIPTION_ACTIVATED, path: '/subscription_activated' },
  { name: SUBSCRIPTION_MEDIA_ACTIVATED, path: '/subscription_activated/media' },
  { name: SUBSCRIPTION_ADULT_ACTIVATED, path: '/subscription_activated/adult' },
  { name: SUBSCRIPTION_AUTHOR_ACTIVATED, path: '/subscription_activated/:authorId' },
  { name: AGENT, path: '/agent/:id' },
  { name: REF, path: '/ref/:ref' },
  { name: USER_REF, path: '/u/:domain' },
  { name: MODEL_UTM, path: '/m/:domain' },
  { name: NOTIFY_SETTINGS, path: '/settings/notify' },
  { name: VERIFICATION_LANDING, path: '/verification' },
  { name: VERIFICATION_APPLY, path: '/verification/apply' },
  { name: SUBSCRIPTION_AUTHOR_OLD, path: '/subscription/author/:authorId' },
  { name: SUBSCRIPTION_AUTHOR, path: '/s/:authorId' },
  { name: SUBSCRIPTION_MEDIA, path: '/subscription/media' },
  { name: SUBSCRIPTION_ADULT, path: '/subscription/adult' },
  { name: SUBSCRIPTION_BASIC, path: '/subscription/basic' },
  { name: CANDY_QR, path: '/candy_qr' },
  { name: TRIAL_LINKS, path: '/trial_links' },
  { name: SUBSCRIPTION_TONKEEPER, path: '/subscription/tonkeeper/:invoiceUrl' },
  { name: SUBSCRIPTION_INFO, path: '/subscription/info/:id' },
  { name: PAY_FORM, path: '/pay/:token' },
  { name: EXPLORE, path: '/explore' },
  { name: HOWTO, path: '/howto' },
  { name: FAQ, path: '/faq' },
  { name: SUBSCRIPTIONS, path: '/subscriptions' },
  { name: PERSONAL_SUBSCRIPTION, path: '/settings/subscription/personal' },
  { name: PERSONAL_SUBSCRIPTION_INFO, path: '/settings/subscription/personal/info' },
  { name: SESSIONS, path: '/settings/sessions' },
  { name: PASSKEY, path: '/settings/passkey' },
  { name: API_TOKEN, path: '/settings/api_token' },
  { name: OAUTH_AUTHORIZE, path: '/oauth/authorize' },
  { name: BLACKLIST, path: '/settings/blacklist' },
  { name: APP, path: '/app/:id' },
  { name: APPS_MANAGE, path: '/apps/manage' },
  { name: SYSTEM_PROMO_CODE, path: '/promo_code' },
  { name: PROMO_CODE, path: '/code/:code' },
  { name: POST_VIEW, path: '/post:id' },
  { name: RESOLVE, path: '/:domain' },
  { name: STORAGE, path: '/storage' },
  { name: WEBSITE_SETTINGS, path: '/settings/website_settings' },
  { name: STATISTICS, path: '/statistics' },
  { name: STATISTICS_PRO, path: '/statistics/pro' },
  { name: STATISTICS_PRO_FANS, path: '/statistics/pro/fans' },
  { name: STATISTICS_PRO_LINKS, path: '/statistics/pro/links?:linkId' },
  { name: NFT, path: '/nft' },
  { name: SHARE_PROFILE, path: '/s/:domain' },
  { name: GOOGLE_AUTH, path: '/google_auth' },
  { name: CLOUD, path: '/cloud?:albumId' },
  { name: ADS, path: '/ads' },
  { name: TOP_UP_FAILED, path: '/topup/failed' },
  { name: LISTS, path: '/lists' },
  { name: LIST, path: '/lists/:id' },
  { name: INCOGNITO, path: '/incognito' },
  { name: LIVE, path: '/live/:id' },
  { name: PROFILE_LIVE, path: '/:domain/live' },
  { name: PRE_LANDING_V1, path: '/l/quiz1' },
  { name: PRE_LANDING_V2, path: '/l/quiz2' },
  { name: PRE_LANDING_V3, path: '/l/model/:id' },
  { name: BATTLE, path: '/battle/:id' },
  { name: BATTLES, path: '/battles' },
  { name: STORY_LANDING, path: '/l/story/:id' },
  { name: LANDING_DIAMOND, path: '/l/diamond' },
  { name: BOT, path: '/bot' },
  { name: REF_LANDING, path: '/ref_lading' },
  { name: VALENTINE_DAY_STICKER, path: '/valentine/:userId' },
  { name: REELS, path: '/clips' },
  { name: MARYANA_LANDING, path: '/maryana_landing' },
  { name: DASHBOARD, path: '/dashboard' },
  { name: PAYMENT_METHODS, path: '/payment_methods' },
  { name: REFILL_TON, path: '/refill_ton' },
  { name: SHOW_SUBSCRIPTION, path: '/s/show' },
  { name: ISOLATED_MODE, path: '/isolated' },
  { name: TELEGRAM, path: '/telegram' },
  { name: OFFERS, path: '/offers' },
  { name: VIEW_OFFER, path: '/offer/:id' },
  { name: MINE, path: '/mine' },
  { name: MINE_SQUAD, path: '/mine/squad/:id' },
  { name: MINE_BOOST, path: '/mine/boost' },
  { name: MINE_TOP, path: '/mine/top' },
  { name: MINE_FRIENDS, path: '/mine/friends' },
  { name: MINE_SQUAD_BOOST, path: '/mine/squad/:id/boost' },
  { name: MINE_EXPLORE, path: '/mine/explore' },
  { name: ONLYPAY_SUCCESS, path: '/onlypay/success' },
  { name: ONLYPAY_ERROR, path: '/onlypay/error' },
  { name: TOP_UP, path: '/top_up' },
  { name: LEADERBOARD, path: '/leaderboard' },
  { name: LEADERBOARD_DETAILS, path: '/leaderboard/:id/details' },
  { name: LEADERBOARDS_HISTORY, path: '/leaderboards/history' },
  { name: CUSTOM_TIPS, path: '/custom_tips/:authorId' },
  { name: BLACK_FRIDAY_2025, path: '/blackfriday2025' },
  ...(!IS_PRODUCTION ? [{ name: DEBUG_PAGE, path: '/debug-page' }] : []),

  // ADMIN PANEL
  { name: ADMIN, path: '/admin' },
  { name: ADMIN_FINANCE, path: '/admin/finance' },
  { name: ADMIN_USERS, path: '/admin/users' },
  { name: ADMIN_REPORTS, path: '/admin/reports' },
  { name: ADMIN_SPAM_CASES, path: '/admin/spam-cases' },
  { name: ADMIN_SPAM_CASE, path: '/admin/spam-cases/:caseId' },
  { name: ADMIN_MODERATIONS, path: '/admin/moderations' },
  { name: ADMIN_MODERATIONS_LIST, path: '/admin/moderations/list' },
  { name: ADMIN_MODERATION_STATS, path: '/admin/moderations/stats' },
  { name: ADMIN_MODERATION_QUEUE, path: '/admin/moderations/queue/:queueKey' },
  { name: ADMIN_MODERATION, path: '/admin/moderations/any' },
  { name: ADMIN_MODERATION_VIEW, path: '/admin/moderations/:moderationId' },
  { name: ADMIN_OTHER, path: '/admin/other' },
  { name: ADMIN_ADS, path: '/admin/ads' },
  { name: ADMIN_USER_PROFILE, path: '/admin/users/:userId' },
  { name: ADMIN_UTM_MODEL_LIST, path: '/admin/utm/models' },
  { name: ADMIN_MODEL_ADS, path: '/admin/models/ads' },
  { name: ADMIN_ACTIONS_STATS, path: '/admin/actions_stats' },
  { name: ADMIN_PROMO_CODES, path: '/admin/codes' },
  { name: ADMIN_PROMO_CODE, path: '/admin/code/:code' },
  { name: PWA_IOS, path: '/pwa/ios' },
  { name: ADMIN_MESSAGES, path: '/admin/messages' },
  { name: ADMIN_CHATS, path: '/admin/chats' },
  { name: ADMIN_BROADCASTS, path: '/admin/broadcasts' },
  { name: ADMIN_TRANSLATIONS, path: '/admin/translations' },
  { name: ADMIN_TRANSACTIONS, path: '/admin/transactions' },
  { name: ADMIN_TRANSLATIONS_LANGUAGE, path: '/admin/translations/:langCode' },
  { name: ADMIN_TOP, path: '/admin/top' },
  { name: ADMIN_BATTLE, path: '/admin/battle' },
  { name: ADMIN_BATTLE_CREATE, path: '/admin/battle/create' },
  { name: ADMIN_WITHDRAWALS, path: '/admin/withdrawals' },
  { name: TRIAL_LINK_ACTIVATION, path: '/trial/:hash' },
  { name: ADMIN_MINE_EXPLORE_CARDS, path: '/admin/explore/cards' },
  { name: ADMIN_AUDIT_LOG, path: '/admin/audit' },
  { name: ADMIN_MODERATION_LOGS, path: '/admin/moderation-logs' },
  { name: ADMIN_BLACKLIST, path: '/admin/blacklist' },
];

export const PWA_ROUTES_EXCLUDE = [
  ADD_ACCOUNT,
  REGISTRATION,
  SUBSCRIPTION,
  SUBSCRIPTION_MEDIA,
  SUBSCRIPTION_ADULT,
  SUBSCRIPTION_ACTIVATED,
  PRE_LANDING_V1,
  PRE_LANDING_V2,
  STORY_LANDING,
  REELS,
  LIVE,
  ADULT_AUTH,
  VERIFICATION_LANDING,
  VERIFICATION_APPLY,
  MINE,
];

const routesTree = {
  [IM]: [CHAT, STORAGE, BROADCAST, BROADCAST_MESSAGE, BROADCAST_STATS],
  [PROFILE_REDIRECT]: [NFT],
  [OTHER]: {
    ADS,
    CLOUD,
    INVITE,
    STATISTICS: [],
    STATISTICS_PRO: [],
    STATISTICS_PRO_FANS: [],
    STATISTICS_PRO_LINKS: [],
    SUBSCRIPTIONS: [
      SUBSCRIPTION_TONKEEPER,
      SUBSCRIPTION,
      SUBSCRIPTION_INFO,
      SUBSCRIPTION_MEDIA_ACTIVATED,
      SUBSCRIPTION_ADULT_ACTIVATED,
      SUBSCRIPTION_AUTHOR_ACTIVATED,
    ],

    CONTENT_PRIORITY: [],
    GENDER_FILTER: [],
    SETTINGS: [
      ADD_ACCOUNT,
      LANGUAGE,
      PASSKEY,
      API_TOKEN,
      PASSWORD,
      BIND_EMAIL,
      WELCOME_MESSAGE,
      NOTIFY_SETTINGS,
      PERSONAL_SUBSCRIPTION,
      PERSONAL_SUBSCRIPTION_INFO,
      WEBSITE_SETTINGS,
      BLACKLIST,
    ],
    LISTS: [LIST],
    BATTLES: [BATTLE],
  },
  [ADMIN]: {
    ADMIN_FINANCE,
    ADMIN_USERS: [ADMIN_USER_PROFILE],
    ADMIN_REPORTS,
    ADMIN_SPAM_CASES: [ADMIN_SPAM_CASE],
    ADMIN_MODERATIONS: [
      ADMIN_MODERATIONS_LIST,
      ADMIN_MODERATION_STATS,
      ADMIN_MODERATION_QUEUE,
      ADMIN_MODERATION,
      ADMIN_MODERATION_VIEW,
    ],
    ADMIN_OTHER,
    ADMIN_ADS,
    ADMIN_CHATS,
    ADMIN_MESSAGES,
    ADMIN_TRANSLATIONS: [ADMIN_TRANSLATIONS_LANGUAGE],
    ADMIN_TRANSACTIONS,
    ADMIN_AUDIT_LOG,
    ADMIN_MODERATION_LOGS,
    ADMIN_BLACKLIST,
  },
  [FEED]: [SUBSCRIPTION_MEDIA, SUBSCRIPTION_ADULT],
  [RESOLVE]: [SUBSCRIPTION_AUTHOR],
  [POST_VIEW]: [FEED],
  [MINE]: [MINE_SQUAD, MINE_TOP, MINE_BOOST, MINE_EXPLORE],
};

export const getRouteParent = (routeName: string) => {
  const recursive = (tree, routeName: string, parent: string | null = null) => {
    if (Array.isArray(tree) && tree.includes(routeName)) {
      return parent;
    } else if (typeof tree === 'object') {
      for (const key of Object.keys(tree)) {
        if (key === routeName) {
          return parent;
        }
        const route = recursive(tree[key], routeName, key);
        if (route) {
          return route;
        }
      }
    }
    return null;
  };

  return recursive(routesTree, routeName);
};

const router = createRouter(routes, {
  allowNotFound: true,
  autoCleanUp: false,
  defaultRoute: 'home',
  defaultParams: {},
  queryParamsMode: 'loose',
  trailingSlashMode: 'default',
  strictTrailingSlash: false,
  caseSensitive: false,
  urlParamsEncoding: 'default',
});

router.usePlugin(browserPlugin());
router.usePlugin(listenersPlugin());

let history: any = [];
let isBack = false;
let lastScrollTop = 0;

export function isBackNavigation() {
  return isBack;
}

export function getLastScrollTop() {
  return lastScrollTop;
}

function parseRouteName(route) {
  if (!route) {
    return 'none';
  }
  //
  // if (route.params && route.params.w) {
  //   return route.params.w;
  // }

  return route.path;
}

// in-app history entries behind the current one; lives in history.state so popstate restores it
export function getHistoryDepth(): number {
  return window.history?.state?.meta?.depth ?? 0;
}

router.useMiddleware((router) => (toState, fromState, done) => {
  const transition = window.history?.state?.meta?.options?.transition;
  if (!fromState && transition && toState.meta) {
    toState.meta.options = {
      transition,
    };
  }
  if (toState && fromState) {
    if (toState.meta?.options) {
      const transition = toState.meta?.options?.transition;
      toState.meta.options.transition = transition || transition === undefined;
      toState.meta.options.previousRoute =
        toState.name !== fromState.name
          ? fromState.name
          : window.history?.state?.meta?.options?.previousRoute;
    }
  }
  if (toState.meta) {
    const pushed =
      !!fromState && toState.meta.source !== 'popstate' && !toState.meta.options?.replace;
    (toState.meta as NonNullable<typeof toState.meta> & { depth?: number }).depth =
      getHistoryDepth() + (pushed ? 1 : 0);
  }
  done();
});

/* @ts-ignore */
router.addListener((from, to) => {
  const fromName = parseRouteName(from);
  const toName = parseRouteName(to);

  const lastHistory = history.length > 0 ? history[history.length - 1] : null;

  if (lastHistory && lastHistory.from === toName && lastHistory.to === fromName) {
    history.pop();
    isBack = true;
    lastScrollTop = lastHistory.scrollTop;
  } else {
    let scrollNode = document.querySelector('.Modal__cont ._ScrollView');
    if (!scrollNode) {
      scrollNode = document.querySelector('._ScrollView');
    }

    history.push({
      from: fromName,
      to: toName,
      scrollTop: scrollNode?.scrollTop ?? 0,
    });
    isBack = false;
  }

  if ((to?.path ?? '').match(/w=play/) && (from?.path ?? '').match(/w=play/)) {
    // skip scroll
  } else {
    //window.scrollTo(0, 0);
  }

  sendEvent('page_viewed');
});

export default router;
